import React, { useEffect, useState } from "react";
import { adminApi } from "../../lib/api";
import { Users, ScanLine, Gift, Coins } from "lucide-react";

export default function AdminDashboard() {
    const [s, setS] = useState(null);
    useEffect(() => {
        adminApi.get("/api/admin/stats").then((r) => setS(r.data));
    }, []);
    if (!s) return <div className="text-[#6b7280]">Loading…</div>;

    return (
        <div>
            <h1 className="font-display text-3xl font-bold">Dashboard</h1>
            <p className="text-[#6b7280] text-sm">Live overview of Fundlexperiences ecosystem</p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-6">
                <Stat icon={Users} label="Customers" value={s.customers} accent="#ccff00" />
                <Stat icon={ScanLine} label="Bills total" value={s.bills.total} accent="#ffd700" />
                <Stat icon={Gift} label="Rewards live" value={s.catalog.rewards} accent="#ff4d4d" />
                <Stat icon={Coins} label="Outstanding pts" value={s.points.outstanding.toLocaleString("en-IN")} accent="#ccff00" />
            </div>

            <div className="grid md:grid-cols-2 gap-4 mt-6">
                <div className="fx-card p-5">
                    <h3 className="font-display font-semibold">Bills</h3>
                    <div className="grid grid-cols-3 gap-3 mt-3">
                        <Mini label="Approved" v={s.bills.approved} color="#ccff00" />
                        <Mini label="Moderation" v={s.bills.moderation} color="#ffd700" />
                        <Mini label="Rejected" v={s.bills.rejected} color="#ff4d4d" />
                    </div>
                </div>
                <div className="fx-card p-5">
                    <h3 className="font-display font-semibold">Points economics</h3>
                    <div className="grid grid-cols-3 gap-3 mt-3">
                        <Mini label="Earned" v={s.points.earned.toLocaleString("en-IN")} color="#ccff00" />
                        <Mini label="Redeemed" v={s.points.redeemed.toLocaleString("en-IN")} color="#ff4d4d" />
                        <Mini label="Outstanding" v={s.points.outstanding.toLocaleString("en-IN")} color="#ffd700" />
                    </div>
                </div>
                <div className="fx-card p-5">
                    <h3 className="font-display font-semibold">Redemptions</h3>
                    <div className="grid grid-cols-2 gap-3 mt-3">
                        <Mini label="Total" v={s.redemptions.total} color="#fff" />
                        <Mini label="Issued" v={s.redemptions.issued} color="#ccff00" />
                    </div>
                </div>
                <div className="fx-card p-5">
                    <h3 className="font-display font-semibold">Catalog</h3>
                    <div className="grid grid-cols-2 gap-3 mt-3">
                        <Mini label="Brands" v={s.catalog.brands} color="#fff" />
                        <Mini label="Rewards" v={s.catalog.rewards} color="#fff" />
                    </div>
                </div>
            </div>
        </div>
    );
}

function Stat({ icon: I, label, value, accent }) {
    return (
        <div className="fx-card p-4">
            <div className="w-9 h-9 rounded-xl flex items-center justify-center mb-2" style={{ background: `${accent}22`, color: accent }}>
                <I size={18} />
            </div>
            <p className="text-[11px] uppercase tracking-widest text-[#6b7280]">{label}</p>
            <p className="font-display text-2xl font-bold mt-1">{value}</p>
        </div>
    );
}

function Mini({ label, v, color }) {
    return (
        <div className="rounded-xl bg-white/[0.03] border border-[rgba(11,20,55,0.05)] p-3">
            <p className="text-[10px] uppercase tracking-widest text-[#6b7280]">{label}</p>
            <p className="font-display text-xl font-bold mt-0.5" style={{ color }}>{v}</p>
        </div>
    );
}
